import { NgModule } from '@angular/core';
import { IgnoreNullPipe } from './ignore-null.pipe';
import { WithoutRetiredPipe } from './without-retired.pipe';
import { ArrangementPipe } from './arrangement.pipe';
import { ServiceProviderPipe } from './service-provider.pipe';
import { ServiceProviderByTagPipe } from './service-provider-by-tag.pipe';
import { ServiceProviderByServiceTypePipe } from './service-provider-by-service-type.pipe';
import { ServiceProviderServiceByServiceTypePipe } from './service-provider-service-by-service-type.pipe';
import { SortPipe } from './sort.pipe';
import { FilterPipe } from './filter.pipe';
import { SafePipe } from './html-safe.pipe';
import { EventTransferPipe } from './event-transfer.pipe';
import { DisposalTransferPipe } from './disposal-transfer.pipe';
import { PreparationTransferPipe } from './preparation-transfer.pipe';
import { DocumentPipe } from './document.pipe';
import { FileSizePipe } from './file-size.pipe';
import { FilterContactsPipe } from './filter-contacts.pipe';
import { FilterDocumentsPipe } from './filter-documents.pipe';
import { ArrangementRegionPipe } from './arrangement-region.pipe';
import { ArrangementStatusPipe } from './arrangement-status.pipe';
import { ArrangementOrderPipe } from './arrangement-order.pipe';
import { ArrangementOwnerPipe } from './arrangement-owner.pipe';
import { TaskPipe } from './task.pipe';
import { TaskRemovedPipe } from './task-removed.pipe';
import { IsNotDeletedPipe } from './is-not-deleted.pipe';
import { AddressToStringPipe } from './address-to-string.pipe';
import { InvalidLinkedTransfersPipe } from './invalid-linked-transfers.pipe';
import { LinkedTransferByIdPipe } from './linked-transfer-by-id.pipe';
import { TransferFilterPipe } from './transfer-filter.pipe';
import { ClientTypeNamePipe } from './client-type-name.pipe';

const pipeArray = [
  IgnoreNullPipe,
  WithoutRetiredPipe,
  ArrangementPipe,
  ServiceProviderPipe,
  ServiceProviderByTagPipe,
  ServiceProviderByServiceTypePipe,
  ServiceProviderServiceByServiceTypePipe,
  SortPipe,
  FilterPipe,
  SafePipe,
  EventTransferPipe,
  DisposalTransferPipe,
  PreparationTransferPipe,
  DocumentPipe,
  FileSizePipe,
  FilterContactsPipe,
  FilterDocumentsPipe,
  ArrangementRegionPipe,
  ArrangementStatusPipe,
  ArrangementOrderPipe,
  ArrangementOwnerPipe,
  ClientTypeNamePipe,
  TaskPipe,
  TaskRemovedPipe,
  IsNotDeletedPipe,
  AddressToStringPipe,
  InvalidLinkedTransfersPipe,
  LinkedTransferByIdPipe,
  TransferFilterPipe,
];

@NgModule({
  declarations: pipeArray,
  exports: pipeArray,
})
export class PipeModule {}
